import { h } from '@atomify/jsx';

interface CheckboxListProps {
    requiredErrorMessage?: string;
    required?: boolean;
    title?: string;
    children?: NodeList;
}

const CheckboxListElement = (props: CheckboxListProps) => {
    return (
        <bpd-checkbox-list
            class="c-checkbox-list form__item"
            required-error-message={props.requiredErrorMessage}
            required={props.required}>
            <span class="form__label">{props.title}</span>
            <div class="checkbox-list__wrapper">{props.children}</div>
            <div class="form__item-error" role="alert"></div>
        </bpd-checkbox-list>
    );
};

export { CheckboxListElement };
